import { ChangeDetectionStrategy, Component } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { TranslateModule } from '@ngx-translate/core';

/**
 * Confirms whether the user wants to leave the nutrition onboarding wizard
 * with unsaved changes. Used by the CanDeactivate guard and shaped so the
 * `confirm` action returns true, `cancel` returns false (or closes via
 * backdrop click).
 */
@Component({
  selector: 'app-onboarding-discard-dialog',
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [MatDialogModule, MatButtonModule, TranslateModule],
  template: `
    <h2 mat-dialog-title>{{ 'nutrition.onboarding.discard.title' | translate }}</h2>
    <mat-dialog-content>
      <p>{{ 'nutrition.onboarding.discard.body' | translate }}</p>
    </mat-dialog-content>
    <mat-dialog-actions align="end">
      <button mat-button (click)="ref.close(false)">
        {{ 'nutrition.onboarding.discard.cancel' | translate }}
      </button>
      <button mat-flat-button color="warn" (click)="ref.close(true)">
        {{ 'nutrition.onboarding.discard.confirm' | translate }}
      </button>
    </mat-dialog-actions>
  `,
})
export class OnboardingDiscardDialogComponent {
  constructor(public ref: MatDialogRef<OnboardingDiscardDialogComponent, boolean>) {}
}
